import { classNames } from '../../../shared/lib/classNames/classNames'
import classes from './AdminPage.module.scss'
import { HeaderTypography } from '../../../shared/ui/HeaderTypography/HeaderTypography'
import React, { SyntheticEvent } from 'react'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { CustomTabPanel } from '../../../shared/ui/CustomTabPanel/CustomTabPanel'
import { DisplayNotifications } from '../../../features/DisplayNotifications'
import Button from '@mui/material/Button'
import { SvgIcon } from '../../../shared/ui/SvgIcon/SvgIcon'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import Tooltip from '@mui/material/Tooltip'
import {
	useSessionStorage
} from '../../../shared/lib/hooks/useSessionStorage/useSessionStorage'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { modalActions, ModalTypes } from '../../../entities/Modal'
import { DisplayClientLabels } from '../../../features/DisplayClientLabels'

const tabsData = [
	{
		name: 'globalNotifications',
		content: <DisplayNotifications />,
		label: 'Global Notifications'
	},
	{
		name: 'clientLabels',
		content: <DisplayClientLabels />,
		label: 'Client labels'
	}
]

export const AdminPage = () => {
	const dispatch = useAppDispatch()
	const [tabValue, setTabValue] = useSessionStorage('adminPanelTab', 'globalNotifications')

	const handleChange = (_event: SyntheticEvent, newValue: 'string') => {
		setTabValue(newValue)
	}

	const handleAddClientLabel = () => {
		dispatch(modalActions.showModal({
			modalType: ModalTypes.NEW_CLIENT_LABEL_MODAL
		}))
	}

	return (
		<div className={classNames(classes['admin-page'])}>
			<HeaderTypography content={'Admin panel'} />
			<Paper sx={{ width: '100%', p: '2rem', pt: '1rem', mt: 4 }}>
				<Box sx={{ width: '100%' }}>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							borderBottom: 1,
							borderColor: 'divider'
						}}>
						<Tabs
							value={tabValue}
							onChange={handleChange}
						>
							{tabsData.map(tab => (
								<Tab
									key={tab.name}
									value={tab.name}
									label={tab.label}
								/>
							))}
						</Tabs>
						{tabValue === 'clientLabels' && (
							<Tooltip title="Add client label" placement="top">
								<Button
									variant="contained"
									component={'span'}
									size="small"
									sx={{ ml: 'auto', minWidth: '2rem', height: '2rem' }}
									onClick={handleAddClientLabel}
								>
									<SvgIcon icon={faPlus} />
								</Button>
							</Tooltip>
						)}
					</Box>
					{tabsData.map(tab => (
						<CustomTabPanel
							key={tab.name}
							index={tab.name}
							value={tabValue}
						>
							{tab.content}
						</CustomTabPanel>
					))}
				</Box>
			</Paper>
		</div>
	)
}

